import { render, staticRenderFns } from "./lrDate.vue?vue&type=template&id=134bae2a&"
import script from "./lrDate.vue?vue&type=script&lang=js&"
export * from "./lrDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports